import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/travis/gopath/src/github.com/rumblefrog/source-chat-relay/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "tips-and-tricks"
    }}>{`Tips-And-Tricks`}</h1>
    <p>{`Some miscellaneous tips & tricks`}</p>
    <h2 {...{
      "id": "global-broadcast"
    }}>{`Global Broadcast`}</h2>
    <p>{`If you wish to either receive or send on all channels, simply set `}<inlineCode parentName="p">{`-1`}</inlineCode>{` as the receive/send channel`}</p>
    <p>{`This is especially useful if you wish to have an announcement channel in your Discord server, you can simply set the send channel to -1, and it will broadcast to every single channel, serving the announcement to everyone`}</p>
    <h2 {...{
      "id": "cross-entities"
    }}>{`Cross-Entities`}</h2>
    <p>{`By setting two game server/text channel on the same channel, you can enable cross-talk across servers/text channels`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      